import {get, post, post2, get2} from './base'

const LIST = '/api/vendorInfo/list'
const CHECK_LIST = '/api/vendorInfo/checkList'
const EDIT = '/api/vendorInfo/edit'

const POINT_CHARGE = '/api/vendorManage/pointCharge'
const POINT_DEDUCT = '/api/vendorManage/pointDeduct'
const POINT_RECORD = '/api/vendorManage/pointRecord'
const DISABLE = '/api/vendorManage/disable'
const COUPON_LIST = '/api/vendorManage/couponList'

const ACCEPT = '/api/vendorInfo/checkAccept'

export default {
    getVendorList( params) {
        return get(LIST,params);
    },
    edit( params) {
        return post(EDIT, params)
    },
    getCheckList( params) {
        return get(CHECK_LIST, params)
    },
    accept( params) {
        return post(ACCEPT, params)
    },
    pointCharge(params) {
        return post(POINT_CHARGE, params)
    },
    pointDeduct(params) {
        return post(POINT_DEDUCT, params)
    },
    pointRecord(params) {
        return get(POINT_RECORD, params)
    },
    disable(params) {
        return post2(DISABLE, params)
    },
    couponList(params) {
        return get2(COUPON_LIST, params)
    }
}
